/**
 *
 *
 *
 */
const init = function () {

	// this will fire after gravity forms has rendered the form
	jQuery(document).on('gform_post_render', function () {

		const fields = document.querySelectorAll('.gquiz-field');

		if (fields.length > 0) {
			setupListeners(fields);
			doPostRender();
		}

	});

};


/**
 *
 *
 *
 */
const setupListeners = function (fields) {

	Array.prototype.forEach.call(fields, (field) => {
		field.addEventListener('click', (event) => {
			onClickActions(event);
		});
	});

};


/**
 *
 *
 *
 */
const doPostRender = function () {

	const filter = Array.prototype.filter;
	const nodeList = document.querySelectorAll('.gform_page');

	if (nodeList) {

		const filteredNode = filter.call(nodeList, (node) => {
			return !node.getAttribute('style');
		});

		const list_parent = filteredNode[0].querySelectorAll('.gfield_radio');

		disableOptions(list_parent[0]);

	}

};


/**
 *
 *
 */
const disableOptions = function (list) {

	const options = list.querySelectorAll('input[type="radio"]');
	let completed = false;

	// First check to see if there is a checked radio button
	Array.prototype.forEach.call(options, (option) => {
		if (option.checked) {
			completed = true;
		}
	});

	// If the form has been completed, then disable the other options
	if (completed) {
		Array.prototype.forEach.call(options, (option) => {
			if (!option.checked) {
				option.setAttribute('disabled', '');
			}
		});

		list.classList.add('is-answered');
	}

};


/**
 *
 *
 *
 */
const onClickActions = function (event) {

	const target = event.target;

	if (target.tagName === 'INPUT') {
		const list = event.target.parentNode.parentNode;
		setListAsCompleted(list);
	}

};


/**
 *
 *
 *
 */
const setListAsCompleted = function (list) {
	disableOptions(list);
};


const api = {
	init: init
};

export default api;